/**
 * Derive a 4-digit pickup code from a membership ID.
 * Uses Knuth multiplicative hashing for even distribution
 * and to prevent sequential IDs from producing predictable codes.
 */
export function pickupCode(membershipId: number): string {
  const hash = Math.imul(membershipId, 2654435761) >>> 0;
  return String(hash % 10000).padStart(4, "0");
}
